import { render, staticRenderFns } from "./PrivacyFormHeader.vue?vue&type=template&id=14382905&scoped=true&"
import script from "./PrivacyFormHeader.vue?vue&type=script&lang=js&"
export * from "./PrivacyFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyFormHeader.vue?vue&type=style&index=0&id=14382905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14382905",
  null
  
)

export default component.exports